/**
 * Shared parse helpers for Kalshi fixed-point API migration.
 * Centralizes dual-read logic: prefer new _dollars/_fp fields, fall back to legacy.
 */

/** Parse a dollar string ("0.43") to cents integer (43). Falls back to legacy number. */
export function dollarsToCents(dollars: unknown, legacyCents: unknown): number | null {
  if (typeof dollars === 'string') {
    const n = Number(dollars);
    if (Number.isFinite(n)) return Math.round(n * 100);
  }
  if (typeof legacyCents === 'number' && Number.isFinite(legacyCents)) {
    return Math.round(legacyCents);
  }
  return null;
}

/** Parse a fixed-point string ("10.00") to integer (10). Falls back to legacy number. */
export function fpToInt(fp: unknown, legacyInt: unknown): number | null {
  if (typeof fp === 'string') {
    const n = Number(fp);
    if (Number.isFinite(n)) return Math.round(n);
  }
  if (typeof legacyInt === 'number' && Number.isFinite(legacyInt)) {
    return Math.round(legacyInt);
  }
  return null;
}
